import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { AlipayIcon } from './AlipayIcon';
import { BitPayIcon } from './BitPayIcon';
import { ConvenienceStoreIcon } from './ConvenienceStoreIcon';
import { CreditCardIcon } from './CreditCardIcon';
import { FakePaymentMethodIcon } from './FakePaymentMethodIcon';
import { IDealIcon } from './IDealIcon';
import { MercadoPagoIcon } from './MercadoPagoIcon';
import { PagSeguroIcon } from './PagSeguroIcon';
import { PayEasyIcon } from './PayEasyIcon';
import { PayPalIcon } from './PayPalIcon';
import { Privat24Icon } from './Privat24Icon';
import { SofortIcon } from './SofortIcon';
import { UniPayIcon } from './UniPayIcon';
import { YandexIcon } from './YandexIcon';

export const pmIconsMap: any = {
  [PaymentMethod.CreditCard]: CreditCardIcon,
  [PaymentMethod.PayPal]: PayPalIcon,
  [PaymentMethod.MercadoPago]: MercadoPagoIcon,
  [PaymentMethod.PagSeguro]: PagSeguroIcon,
  [PaymentMethod.Yandex]: YandexIcon,
  [PaymentMethod.Sofort]: SofortIcon,
  [PaymentMethod.IDeal]: IDealIcon,
  [PaymentMethod.Alipay]: AlipayIcon,
  [PaymentMethod.ConvenienceStore]: ConvenienceStoreIcon,
  [PaymentMethod.PayEasy]: PayEasyIcon,
  [PaymentMethod.Privat24]: Privat24Icon,
  [PaymentMethod.UniPay]: UniPayIcon,
  [PaymentMethod.BitPay]: BitPayIcon,
  [PaymentMethod.FakePaymentMethod]: FakePaymentMethodIcon,
};
